/* STRNG X unified motion — trigger-once reveals, CSS-first */
(function(){
  if (window.__sxMotion) return; window.__sxMotion = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    var secs = document.querySelectorAll('.sx-sec, .sx-athletes, .sx-cats, .sx-drop-sec, .sx-pack, .sx-doctrine');
    if (reduce || !('IntersectionObserver' in window)){
      secs.forEach(function(s){ s.classList.add('sx-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('sx-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    secs.forEach(function(s){
      s.classList.add('sx-motion');        /* opt-in: nothing hides unless JS is alive */
      /* already in view on load → reveal immediately, no pop */
      var r = s.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { s.classList.add('sx-in'); }
      else { io.observe(s); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
